export enum Direction {
  X = 'X',
  Y = 'Y'
}
